(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_layouts/focus-image/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/banner_layouts/focus-image/assets/javascripts/prescript.js');
svs.banner_layouts = svs.banner_layouts || {};
svs.banner_layouts.focus_image = svs.banner_layouts.focus_image || {};


 })(window);